import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Colors from '../../../../../../../constants/Colors';
import PressableStyled from '../../../../../../../components/PressableStyled';

interface ActivityTabButtonProps {
  select: () => void,
  selected: boolean,
  title: string,
}

const ActivityTabButton = ({
  select, selected, title,
}: ActivityTabButtonProps) => <PressableStyled
  onPress={selected ? null : select}
  style={[styles.button, selected && styles.buttonSelected]}
>
  <Text style={[styles.title, selected && styles.titleSelected]}>{title}</Text>
</PressableStyled>;

const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 12,
    paddingVertical: 8,
    marginRight: 8,
    borderBottomWidth: 4,
    borderBottomColor: 'transparent',
  },
  buttonSelected: {
    borderBottomColor: Colors.light.hereworksBlue500,
  },
  title: {
    fontSize: 12,
    lineHeight: 20,
    fontFamily: 'Roboto_500Medium',
    color: Colors.light.hereworksBlack400,
  },
  titleSelected: {
    color: Colors.light.hereworksBlue500,
  },
});

export default ActivityTabButton;
